import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hidden-submit"
export default class extends Controller {
  static targets = [ "submitBtn" ]

  connect() {
    this.submitBtnTarget.style = "display:none;"
  }

  formSubmit() {
    this.submitBtnTarget.click()
  }
}
